<div class="container">

    <section>
        <div class="row">
            <div class="col-md-8 col-md-offset-2">
                <h1>Alta de Usuario</h1>
                <hr>
                <form autocomplete="off" [formGroup]="formAltaUsuario" (ngSubmit)="onSubmit()">
                    <fieldset>
                        <legend>
                            <h3>Datos personales</h3>
                        </legend>
                        <div class="row">
                            <div class="col-md-6 form-group item-form"
                                [ngClass]="{ 'has-error': formEnviado && formulario.nombreUsuario.errors }">
                                <label for="nombreUsuario">Nombre de Usuario</label>
                                <input type="text" formControlName="nombreUsuario" name="nombreUsuario"
                                    class="form-control" id="nombreUsuario" required="" aria-required="true">
                                <p *ngIf="formEnviado && formulario.nombreUsuario.errors" class="help-block error">
                                    Ingresá un nombre de usuario</p>
                            </div>
                            <div class="col-md-6 form-group item-form"
                                [ngClass]="{ 'has-error': formEnviado && formulario.cargo.errors }">
                                <label for="cargo">Cargo</label>
                                <input type="text" formControlName="cargo" name="cargo" class="form-control" id="cargo"
                                    required="" aria-required="true">
                                <p *ngIf="formEnviado && formulario.cargo.errors" class="help-block error">Ingresá un
                                    cargo</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 form-group item-form"
                                [ngClass]="{ 'has-error': formEnviado && formulario.nombre.errors }">
                                <label for="nombre">Nombres</label>
                                <input type="text" formControlName="nombre" name="nombre" class="form-control"
                                    id="nombre" required="" aria-required="true">
                                <p *ngIf="formEnviado && formulario.nombre.errors" class="help-block error ">Ingresá un
                                    nombre</p>
                            </div>
                            <div class="col-md-6 form-group item-form"
                                [ngClass]="{ 'has-error': formEnviado && formulario.apellido.errors }">
                                <label for="apellido">Apellidos</label>
                                <input type="text" formControlName="apellido" name="apellido" class="form-control"
                                    id="apellido" required="" aria-required="true">
                                <p *ngIf="formEnviado && formulario.apellido.errors" class="help-block error">Ingresá un
                                    apellido</p>
                            </div>
                        </div>
                        <div class="row">

                            <div class="col-md-6">
                                <div class="form-group item-form"
                                    [ngClass]="{ 'has-error': formEnviado && formulario.idTipoDocumento.errors }">
                                    <label for="idTipoDocumento">Tipo de Documento</label>
                                    <select formControlName="idTipoDocumento" id="idTipoDocumento"
                                        name="idTipoDocumento" class="form-control">
                                        <option value="1">DNI</option>
                                        <option value="2">Cédula de Identidad</option>
                                        <option value="3">Libreta de Enrolamiento</option>
                                        <option value="4">Libreta Cívica</option>
                                        <option value="5">Cédula de Ciudadanía</option>
                                        <option value="6">Pasaporte</option>
                                    </select>
                                    <p *ngIf="formEnviado && formulario.idTipoDocumento.errors"
                                        class="help-block error text-danger">
                                        Elegí un tipo de documento</p>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group item-form"
                                    [ngClass]="{ 'has-error': formEnviado && formulario.numeroDocumento.errors }">
                                    <label for="numeroDocumento" id="mostrar-tipo">Número de documento</label>
                                    <input type="text" formControlName="numeroDocumento" min="1" class="form-control"
                                        id="numeroDocumento" name="numeroDocumento" aria-required="true">
                                    <p class="help-block error text-danger"
                                        *ngIf="formEnviado && formulario.numeroDocumento.errors?.required">Ingresá un
                                        número
                                        de
                                        documento</p>
                                    <p class="help-block error text-danger"
                                        *ngIf="formEnviado && formulario.numeroDocumento.errors?.pattern">Ingresá un
                                        documento válido
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 form-group item-form"
                                [ngClass]="{ 'has-error': formEnviado && formulario.cuil.errors }">
                                <label for="cuil">CUIL</label>
                                <input type="text" formControlName="cuil" class="form-control" id="cuil" required=""
                                    aria-required="true" mask="00-00000000-0">
                                <p *ngIf="formEnviado && formulario.cuil.errors?.required" class="help-block error ">
                                    Ingresá un CUIL</p>
                            </div>
                            <div class="col-sm-12 col-md-6"
                                [ngClass]="{ 'has-error': formEnviado && formulario.cuil.errors }">
                                <fieldset>
                                    <legend>
                                        <label>Sexo</label>
                                        <p class="help-block">Como aparece en tu DNI</p>
                                    </legend>
                                    <div class="form-group item-form">
                                        <label for="f" class="radio-inline">
                                            <input type="radio" formControlName="sexo" name="sexo" id="f" value="F"
                                                required="" aria-required="true">
                                            Femenino
                                        </label>
                                        <label for="m" class="radio-inline m-l-3">
                                            <input type="radio" formControlName="sexo" name="sexo" id="m" value="M"
                                                required="" aria-required="true">
                                            Masculino
                                        </label>
                                        <p *ngIf="formEnviado && formulario.sexo.errors?.required"
                                            class="help-block error p-y-1">Ingresá tu sexo</p>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 form-group item-form"
                                [ngClass]="{ 'has-error': formEnviado && formulario.rol.errors }">
                                <label for="rol">Rol</label>
                                <select id="rol" name="rol" formControlName="rol" class="form-control">
                                    <option value="" selected="" disabled>Seleccioná un Rol</option>
                                    <option *ngFor="let rol of listaRoles" [ngValue]="rol.codigo">{{rol.denominacion}}
                                    </option>
                                </select>
                                <p *ngIf="formEnviado && formulario.rol.errors?.required" class="help-block error">
                                    Ingresá un Rol</p>
                            </div>
                            <div class="col-md-6 form-group item-form"
                                [ngClass]="{ 'has-error': formEnviado && formulario.legajo.errors }">
                                <label for="legajo">Legajo</label>
                                <input type="text" formControlName="legajo" name="legajo" class="form-control"
                                    id="legajo" required="" aria-required="true">
                                <p *ngIf="formEnviado && formulario.legajo.errors?.required" class="help-block error">
                                    Ingresá un Legajo</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 form-group item-form"
                                [ngClass]="{ 'has-error': formEnviado && formulario.legajo.errors }">
                                <label for="institucion">Institucion</label>
                                <input type="text" formControlName="institucion" name="institucion" class="form-control"
                                    id="institucion" required="" aria-required="true">
                                <p *ngIf="formEnviado && formulario.institucion.errors?.required"
                                    class="help-block error">Ingresá una Institucion</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 form-group item-form"
                                [ngClass]="{ 'has-error': formEnviado && formulario.email.errors }">
                                <label for="email">Email</label>
                                <input type="email" formControlName="email" name="email" class="form-control" id="email"
                                    required="" aria-required="true">
                                <p *ngIf="formEnviado && formulario.email.errors?.required" class="help-block error">
                                    Ingresá un email</p>
                                <p *ngIf="formEnviado && formulario.email.errors?.email" class="help-block error">
                                    Ingresá un valido email</p>
                            </div>
                            <div class="col-md-6 form-group item-form"
                                [ngClass]="{ 'has-error': formEnviado && formulario.password.errors }">
                                <label for="password">Contraseña:</label>
                                <input type="password" formControlName="password" name="password" class="form-control"
                                    id="password" required="" aria-required="true">
                                <p *ngIf="formEnviado && formulario.password.errors?.required" class="help-block error">
                                    Ingresá una contraseña</p>
                            </div>
                        </div>
                        <div *ngIf="error && !validaciones" aria-live="polite" class="alert alert-warning">
                            <li>{{mensajeError}}</li>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <button routerLink="/gestion-usuarios" class="btn btn-link">Volver</button>
                                <button type="submit" class="btn btn-success m-l-1">Guardar</button>
                            </div>
                        </div>
                    </fieldset>
                </form>
            </div>
        </div>
    </section>
</div>